import { font } from '../tokens/font';
import { radius } from '../tokens/radius';
import { spacing } from '../tokens/spacing';
import { borderWidths } from '../tokens/border-widths';
const partialTheme = {
    fonts: font.family,
    fontSizes: font.size,
    fontWeights: font.weight,
    lineHeights: font.lineHeight,
    radii: radius,
    space: spacing,
    borderWidths,
};
export const baseTheme = partialTheme;
//# sourceMappingURL=base-theme.js.map